import {internalLinkToHref} from '@/modules/foundation/sanity/link/query';
import {PortableText} from '@/modules/foundation/sanity/portable-text';

import {descriptionPortableTextOverrides, GuidebookList} from '../../components/guidebook-list';

import type {GuidebookListAllFragment} from './query';

type Props = {
	data: GuidebookListAllFragment;
	fullWidth?: boolean;
	anchorHeadings?: boolean;
	insideToc?: boolean;
};

export const GuidebookListAllContainer = ({data, anchorHeadings, fullWidth, insideToc}: Props) => {
	const {description, heading, bank, collection, insurance, contentBlockOptions, filter} = data;

	return (
		<GuidebookList
			heading={heading}
			filter={filter}
			description={
				description && description.length > 0 ? (
					<PortableText
						value={description}
						overrideClassNames={descriptionPortableTextOverrides}
					/>
				) : null
			}
			bank={{
				title: bank?.title ?? '',
				href: bank?.slug ? internalLinkToHref(bank._type, bank.slug) : '',
			}}
			collection={{
				title: collection?.title ?? '',
				href: collection?.slug ? internalLinkToHref(collection._type, collection.slug) : '',
			}}
			insurance={{
				title: insurance?.title ?? '',
				href: insurance?.slug ? internalLinkToHref(insurance._type, insurance.slug) : '',
			}}
			anchorHeadings={anchorHeadings}
			options={{
				fullWidth,
				...contentBlockOptions,
			}}
			insideToc={insideToc}
		/>
	);
};
